"use client";
import useTranslate from "@app/_hooks/useTranslate";
import { useCheckoutContext } from "../../Checkout.hooks";
import CheckoutMessage from "../../CheckoutMessage";

export default function WalleyErrorMessage({
  message }: { message: string }) {
  const t = useTranslate();
  useCheckoutContext();

  if (message.includes("Not Found")) {
    return (
      <CheckoutMessage type="error">
        {t("walleyUnknownError") ??
          "Something went wrong. Please try again later."}
      </CheckoutMessage>
    );
  }

  return <CheckoutMessage type="error">{message}</CheckoutMessage>;
}
